// Polyfills
import 'es6-promise/auto'
import 'babel-polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { ColorThemePlugin } from 'vuestic-ui/src/services/ColorThemePlugin'
import store from '../store/index'
import router from '../router/index'
import VuesticPlugin from 'vuestic-ui/src/components/vuestic-plugin'
import '../i18n/index'
import VeeValidate from 'vee-validate'
import '../metrics'
import VuejsDialog from "vuejs-dialog"
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import { Turkish } from "flatpickr/dist/l10n/tr.js";
import vSelect from 'vue-select';

export const axios = require("axios");
axios.defaults.baseURL = process.env.VUE_APP_API_BASE;
axios.defaults.headers.common["client-id"] = process.env.VUE_APP_API_CLIENT_ID;
axios.defaults.headers.common["client-secret"] = process.env.VUE_APP_API_CLIENT_SECRET;
axios.defaults.headers.common["Accept-Language"] = process.env.VUE_APP_API_ACCEPT_LANGUAGE;
if (localStorage.getItem('admin_token')) {
  axios.defaults.headers.common["api-token"] = `${localStorage.getItem('admin_token')}`;
}
window.$axios = axios;

const jsonFormData = require("json-form-data");
window.jsonToFormData = jsonFormData;

// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, { fieldsBagName: 'formFields' })

Vue.use(VuesticPlugin)
Vue.use(ColorThemePlugin,
  {
    themes: {
      primary: '#ed4817',
      secondary: '#0e3e92'
    },
  })
Vue.use(VuejsDialog);
flatpickr.localize(Turkish);
Vue.component('v-select', vSelect);

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  next()
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
})
